module.exports = __webpack_public_path__ + "media/images/bg-pattern-light-deab02c786c1658edba9ac5769d31bd9.svg";